module.exports = __webpack_public_path__ + "static/img/9.46e3c0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxclose/9.png
// module id = QFSM
// module chunks = 1